import React from "react";
import { tmsLogo } from "../../assets/images/tms-image-list";
import "../../assets/css/tms-layout/tms-layout.scss";
// import TmsImageUpload from "../../components/tms-customs/tms-image-upload";
const TmsWelcome = () => {
  return (
    <div className="tms-welcome">
      <div>
        <img src={tmsLogo} height="150px" />
        <h2 style={{ margin: "15px 0px 5px 0px" }}>Divya Saketham</h2>
        <h3>Welcome!</h3>
      </div>
    </div>
  );
};

export default TmsWelcome;
